export default {
	name: 'shellysmknb',
	friendly_name: 'Flood NB',
	family: 'sensor',
	isPM: false,
	is_nb: true,
	availableViews: ['basic'],
	modes: ['sensor'],
	settings: [{ title: 'not_ready' }],
};
